/*
 * Tempo Tribe - require an explicit variant selection before add to cart.
 *
 * The Liquid side ships the product page with nothing pre-selected. This file
 * keeps that true across Dawn's AJAX section re-renders, keeps the shopper's
 * own picks, and blocks / guides the add-to-cart until every option is chosen.
 */
(function () {
  'use strict';

  var STATE = new WeakMap();

  function getState(root) {
    var st = STATE.get(root);
    if (!st) {
      st = { touched: {}, chosen: {}, applying: false, observer: null };
      STATE.set(root, st);
    }
    return st;
  }

  function optionGroups(root) {
    return Array.prototype.slice.call(root.querySelectorAll('variant-selects .product-form__input'));
  }

  function groupSelect(group) {
    return group.querySelector('select');
  }

  function isChosen(group) {
    var select = groupSelect(group);
    if (select) return !!select.value;
    return !!group.querySelector('input[type="radio"]:checked');
  }

  function valueCount(group) {
    var select = groupSelect(group);
    if (select) {
      return Array.prototype.filter.call(select.options, function (o) {
        return o.value !== '';
      }).length;
    }
    return group.querySelectorAll('input[type="radio"]').length;
  }

  function chosenValue(group) {
    var select = groupSelect(group);
    if (select) return select.value || null;
    var input = group.querySelector('input[type="radio"]:checked');
    return input ? input.value : null;
  }

  function restoreGroup(group, value) {
    if (value == null) return false;
    var select = groupSelect(group);
    if (select) {
      var match = Array.prototype.filter.call(select.options, function (o) {
        return o.value === value;
      })[0];
      if (!match) return false;
      Array.prototype.forEach.call(select.options, function (o) {
        o.removeAttribute('selected');
      });
      match.setAttribute('selected', 'selected');
      select.value = value;
      return true;
    }
    var input = Array.prototype.filter.call(group.querySelectorAll('input[type="radio"]'), function (i) {
      return i.value === value;
    })[0];
    if (!input) return false;
    input.checked = true;
    return true;
  }

  function clearGroup(group) {
    var select = groupSelect(group);
    if (select) {
      if (select.value !== '') select.value = '';
      return;
    }
    Array.prototype.forEach.call(group.querySelectorAll('input[type="radio"]:checked'), function (input) {
      input.checked = false;
    });
  }

  function highlight(group, on) {
    if (on) {
      group.style.outline = '2px solid #d32f2f';
      group.style.outlineOffset = '4px';
    } else {
      group.style.outline = '';
      group.style.outlineOffset = '';
    }
  }

  function productForm(root) {
    return root.querySelector('product-form');
  }

  function showError(root, message) {
    var wrapper = root.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;
    var target = wrapper.querySelector('.product-form__error-message');
    if (target) target.textContent = message;
    wrapper.removeAttribute('hidden');
  }

  function hideError(root) {
    var wrapper = root.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.setAttribute('hidden', '');
  }

  function apply(root) {
    var st = getState(root);
    if (st.applying) return;

    var form = productForm(root);
    if (!form || form.dataset.selectionRequired !== 'true') return;

    var groups = optionGroups(root);
    if (!groups.length) return;

    st.applying = true;

    var missing = [];

    groups.forEach(function (group, index) {
      // Options with a single possible value are always considered chosen.
      if (valueCount(group) <= 1) {
        st.touched[index] = true;
      }

      if (st.touched[index]) {
        // A server re-render can come back with the shopper's pick missing
        // (partial option selections do not resolve to a variant). Put it back.
        if (!isChosen(group) && !restoreGroup(group, st.chosen[index])) {
          st.touched[index] = false;
        }
      } else if (isChosen(group)) {
        // Server re-render re-applied a default the shopper never picked.
        clearGroup(group);
      }

      if (st.touched[index]) {
        st.chosen[index] = chosenValue(group);
      }

      if (!isChosen(group)) {
        missing.push(group);
      } else {
        highlight(group, false);
      }
    });

    var complete = missing.length === 0;
    var idInput = root.querySelector('form [name="id"]');
    var button = root.querySelector('.product-form__submit');
    var payment = root.querySelector('[data-payment-buttons]');

    if (!complete) {
      if (idInput) idInput.value = '';
      if (payment) payment.style.display = 'none';
      if (button) {
        // The label is deliberately left as "Add to cart". The submit handler
        // below is what stops an incomplete selection.
        button.setAttribute('data-selection-incomplete', 'true');
      }
    } else {
      if (payment) payment.style.display = 'contents';
      if (button) button.removeAttribute('data-selection-incomplete');
      hideError(root);
    }

    root.dataset.selectionComplete = complete ? 'true' : 'false';
    st.applying = false;
  }

  function observe(root) {
    var st = getState(root);
    if (st.observer) return;

    var scheduled = false;
    st.observer = new MutationObserver(function () {
      if (st.applying || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        apply(root);
      });
    });
    st.observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  function init(root) {
    if (!root || root.dataset.variantRequiredReady === 'true') return;
    var form = productForm(root);
    if (!form) return;
    root.dataset.variantRequiredReady = 'true';

    root.addEventListener('change', function (event) {
      var group = event.target.closest && event.target.closest('.product-form__input');
      if (!group) return;
      var index = optionGroups(root).indexOf(group);
      if (index === -1) return;
      var st = getState(root);
      st.touched[index] = true;
      st.chosen[index] = chosenValue(group);
      highlight(group, false);
      hideError(root);
    });

    observe(root);
    apply(root);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('product-info'), init);
  }

  // Block the add to cart while anything is still unchosen. Capture on document
  // so this runs before Dawn's own submit handler on the form.
  document.addEventListener(
    'submit',
    function (event) {
      var root = event.target.closest && event.target.closest('product-info');
      if (!root) return;
      var form = productForm(root);
      if (!form || form.dataset.selectionRequired !== 'true') return;

      var groups = optionGroups(root);
      var missing = groups.filter(function (group) {
        return valueCount(group) > 1 && !isChosen(group);
      });
      if (!missing.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      missing.forEach(function (group) {
        highlight(group, true);
      });
      showError(root, form.dataset.chooseOptionsText || 'Choose options');
      missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Quick add modals and other sections inject product-info after load.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'PRODUCT-INFO') init(node);
        else if (node.querySelector) initAll(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
